/**
 * the possible view modes for RenewPage
 */
export enum ViewMode {
    /** show the sum of values over all plants */
    Total,
    /** show the sum of values over all plants, separately by region (e.g., North/South) */
    Region,
    /** show the values for each individual plant, possibly only for a subset of all plants */
    Singles,
    /** show the values for a single plant */
    Single,
}
